// Display labels for public.advertisers.billing_method values.
export const BILLING_METHOD_LABELS = {
  credit_card: "Credit Card",
  invoice: "Invoice",
  affiliate_platform: "Affiliate Platform",
};
